import { ComunicacionAjax } from "../../../ts/api/comunicacion";
import type { Respuesta } from "../../../ts/typings/clases";

export function RecuperarContrasenaPage() {
	const onSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		const form = e.target as HTMLFormElement;
		const email = (form.elements.namedItem("email") as HTMLInputElement).value;
		if (!email) {
			alert("Debe introducir un email");
			return;
		}
		void ComunicacionAjax.sendAjaxRequest<Respuesta>("POST", "/recuperarcontrasena", { email }).then(res => {
			if (res.tipo === "exito") {
				alert("Se ha enviado un email con las instrucciones para recuperar la contraseña");
			} else {
				alert("Error al enviar el email: " + (res.message ?? "Error desconocido"));
			}
		});
	};

	return (
		<div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
			<title>Almacen | Recuperar</title>
			<div className="login content-box">
				<div style={{ textAlign: "center", padding: "30px 20px" }}>
					<img src="/img/logoAlmacen.svg" style={{ width: "auto" }} height="240px" />
				</div>

				<div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
					<div style={{ flex: 0.25 }} />
					<form role="form" className="form" onSubmit={onSubmit}>
						<h4 className="text-center">Te enviaremos un e-mail para recuperar la contraseña</h4>

						<div className="form-group">
							<input type="email" className="form-control " name="email" placeholder="E-mail" />
						</div>

						<button type="submit" className="btnPrimary" style={{ width: "100%" }}>
							Enviar e-mail
						</button>
					</form>
					<div style={{ flex: 0.75 }} />
				</div>
			</div>
		</div>
	);
}
